import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as Sentry from '@sentry/react';
import { formatMessage } from 'i18n/CurrentLocale';
import { ModalEnum } from 'myParkdUtils/enums';
import { DeviceMode, ReduxState, Vehicle } from 'types';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';


export const getDeviceModeDisplayName = (deviceMode: DeviceMode): string => {
    switch (deviceMode) {
        case 'MANUAL': return formatMessage({ id: 'PARKING_MODE_MANUAL' });
        case 'SEMI_AUTOMATIC': return formatMessage({ id: 'PARKING_MODE_SEMI_AUTOMATIC' });
        case 'AUTOMATIC': return formatMessage({ id: 'PARKING_MODE_AUTOMATIC' });
        case 'AUTONOMOUS': return formatMessage({ id: 'PARKING_MODE_AUTONOMOUS' });
        case 'MANUAL_SHARED': return formatMessage({ id: 'PARKING_MODE_MANUAL_SHARED' });
        case 'SHARED': return formatMessage({ id: 'PARKING_MODE_SHARED' });
        case 'GLOBALLY_SHARED': return formatMessage({ id: 'PARKING_MODE_GLOBALLY_SHARED' });
        case 'DRY_RUN': return formatMessage({ id: 'PARKING_MODE_DRY_RUN' });
        default:
            console.error(`getDeviceModeDisplayName() - Unhandled deviceMode: ${deviceMode}`);
            Sentry.captureMessage(`getDeviceModeDisplayName() - Unhandled deviceMode: ${deviceMode}`);
            return 'unknown';
    }
}

export const getAllowedDeviceModes = (vehicle: Vehicle, autonomousAllowed: boolean | undefined): DeviceMode[] => {
    const { mode, connection } = vehicle;

    if (mode === 'DRY_RUN') {
        return ['DRY_RUN']
    }
    if (connection === 'APP') {
        return ['MANUAL', 'MANUAL_SHARED'];
    }
    if (autonomousAllowed === true || autonomousAllowed === undefined) {
        return ['MANUAL', 'MANUAL_SHARED', 'SEMI_AUTOMATIC', 'AUTOMATIC', 'AUTONOMOUS', 'SHARED'];
    }
    return ['MANUAL', 'MANUAL_SHARED', 'SEMI_AUTOMATIC', 'AUTOMATIC', 'SHARED'];
}


export const ParkingModeDropdown = (props: ParkingModeDropdownProps) => {
    const { vehicle, autonomousAllowed } = props;
    const initialParkingMode = vehicle.mode;
    const availableModes = getAllowedDeviceModes(vehicle, autonomousAllowed);

    const onchangeParkingMode = (deviceMode: DeviceMode) => {
        props.updateModal(ModalEnum.CHANGE_PARKING_MODE, {
            modalTitle: formatMessage({ id: 'MODAL_TITLE_CHANGE_PARKING_MODE' }),
            vehicle,
            deviceMode
        });
    }

    return (
        <div className='select-wrap'>
            <select name='deviceMode' value={initialParkingMode} onChange={(e) => onchangeParkingMode(e.target.value as DeviceMode)}>
                {availableModes.map((parkingMode) => (
                    <option key={parkingMode} value={parkingMode}>{getDeviceModeDisplayName(parkingMode)}</option>
                ))}
            </select>
        </div>
    )
}


type OwnProps = { vehicle: Vehicle };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
export type ParkingModeDropdownProps = DispatchProps & StateProps & OwnProps;


function mapStateToProps(state: ReduxState) {
    return {
        autonomousAllowed: state.companyDetails?.companyDetails?.autonomousAllowed,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        updateModal: modalWindowActions.updateModalWindow,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ParkingModeDropdown);